//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: 'PtTimePicker',
  props: {
    hideClearButton: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: String,
      default: '',
    },
    minuteInterval: {
      type: Number,
      default: 5,
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: Date,
      default: null,
    },
  },
  data: function data() {
    return {
      apms: ['AM', 'PM'],
      showDropdown: false,
      hour: '',
      minute: '',
      apm: '',
    };
  },
  computed: {
    hours: function hours() {
      var hours = [];

      for (var ii = 1; ii <= 12; ii++) {
        if (ii <= 9) {
          hours.push(("0" + ii));
        } else {
          hours.push(String(ii));
        }
      }

      return hours;
    },
    minutes: function minutes() {
      var minutes = [];

      for (var ii = 0; ii < 60; ii = ii + this.minuteInterval) {
        if (ii <= 9) {
          minutes.push(("0" + ii));
        } else {
          minutes.push(String(ii));
        }
      }

      return minutes;
    },
    displayTime: function displayTime() {
      if (!this.hour && !this.minute && !this.apm) {
        return '';
      }

      return ((this.hour || '00') + ":" + (this.minute || '00') + " " + (this.apm));
    },
    showClearBtn: function showClearBtn() {
      if (this.hideClearButton) { return false; }

      return !this.showDropdown && (!!this.hour || !!this.minute || !!this.apm);
    },
  },
  watch: {
    value: function(newVal) {
      this.setValue(newVal);
    },
  },
  mounted: function mounted() {
    this.setValue(this.value);
  },
  methods: {
    clearTime: function clearTime() {
      this.hour = '';
      this.minute = '';
      this.apm = '';
    },
    emitChange: function emitChange() {
      var hour = parseInt(this.hour || 0, 10);
      hour = this.apm === 'AM' && this.hour === 12 ? 0 : hour;
      hour = this.apm === 'PM' && this.hour !== 12 ? hour + 12 : hour;

      var minute = parseInt(this.minute || 0, 10);
      var date = new Date();
      date.setHours(hour, minute, 0, 0);

      this.$emit('input', date);
      this.$emit('change', date);
    },
    select: function select(type, value) {
      if (type === 'hour') {
        this.hour = value;
        this.minute = this.minute || '00';
        this.apm = this.apm || 'AM';
      } else if (type === 'minute') {
        this.minute = value;
        this.hour = this.hour || '00';
        this.apm = this.apm || 'AM';
      } else if (type === 'apm') {
        this.apm = value;
      }

      this.emitChange();
    },
    setValue: function setValue(val) {
      if (!val) {
        this.clearTime();
        return;
      }

      var date = new Date(val);
      var hour = date.getHours();
      var minute = date.getMinutes();
      var apm = hour >= 12 ? 'PM' : 'AM';
      hour = hour > 12 ? hour - 12 : hour;
      hour = hour <= 9 ? ("0" + hour) : hour;

      this.hour = String(hour);
      this.minute = minute <= 9 ? ("0" + minute) : String(minute);
      this.apm = apm;
    },
    resetTime: function resetTime() {
      this.clearTime();
      this.$emit('input', null);
      this.$emit('change', null);
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
  },
};

function normalizeComponent(compiledTemplate, injectStyle, defaultExport, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, isShadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof isShadowMode === 'function') {
        createInjectorSSR = createInjector;
        createInjector = isShadowMode;
        isShadowMode = false;
    }
    // Vue.extend constructor export interop
    const options = typeof defaultExport === 'function' ? defaultExport.options : defaultExport;
    // render functions
    if (compiledTemplate && compiledTemplate.render) {
        options.render = compiledTemplate.render;
        options.staticRenderFns = compiledTemplate.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyle) {
                injectStyle.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (injectStyle) {
        hook = isShadowMode
            ? function () {
                injectStyle.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
            }
            : function (context) {
                injectStyle.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return defaultExport;
}

/* script */
            var __vue_script__ = script;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("span", { staticClass: "pt-timepicker" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.displayTime,
          expression: "displayTime"
        }
      ],
      class: _vm.inputClass,
      attrs: { placeholder: _vm.placeholder, readonly: "", type: "text" },
      domProps: { value: _vm.displayTime },
      on: {
        click: function($event) {
          $event.stopPropagation();
          return _vm.toggleDropdown($event)
        },
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.displayTime = $event.target.value;
        }
      }
    }),
    _vm._v(" "),
    _vm.showClearBtn
      ? _c(
          "span",
          {
            staticClass: "clear-btn",
            on: {
              click: function($event) {
                $event.stopPropagation();
                return _vm.resetTime($event)
              }
            }
          },
          [_vm._v("\n      ×\n    ")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showDropdown
      ? _c("div", {
          staticClass: "overlay",
          on: {
            click: function($event) {
              $event.stopPropagation();
              return _vm.toggleDropdown($event)
            }
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.showDropdown
      ? _c("div", { staticClass: "dropdown" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "select-list" }, [
            _c(
              "ul",
              { staticClass: "hours" },
              _vm._l(_vm.hours, function(hr) {
                return _c(
                  "li",
                  {
                    key: hr,
                    class: { active: _vm.hour === hr },
                    on: {
                      click: function($event) {
                        $event.stopPropagation();
                        _vm.select("hour", hr);
                      }
                    }
                  },
                  [_vm._v("\n            " + _vm._s(hr) + "\n          ")]
                )
              })
            ),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "minutes" },
              _vm._l(_vm.minutes, function(m) {
                return _c(
                  "li",
                  {
                    key: m,
                    class: { active: _vm.minute === m },
                    on: {
                      click: function($event) {
                        $event.stopPropagation();
                        _vm.select("minute", m);
                      }
                    }
                  },
                  [_vm._v("\n            " + _vm._s(m) + "\n          ")]
                )
              })
            ),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "apms" },
              _vm._l(_vm.apms, function(a) {
                return _c(
                  "li",
                  {
                    key: a,
                    class: { active: _vm.apm === a },
                    on: {
                      click: function($event) {
                        $event.stopPropagation();
                        _vm.select("apm", a);
                      }
                    }
                  },
                  [_vm._v("\n            " + _vm._s(a) + "\n          ")]
                )
              })
            )
          ])
        ])
      : _vm._e()
  ])
};
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", { staticClass: "select-list-label" }, [
      _c("label", [_vm._v("HH")]),
      _vm._v(" "),
      _c("label", [_vm._v("MM")]),
      _vm._v(" "),
      _c("label", [_vm._v("AM/PM")])
    ])
  }
];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Timepicker = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

export { Timepicker as PtTimepicker };
